import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import frontendAvatarUrl from '../../../images/home/hero/developer-avatar.png';

const Hero = () => (
  <section className="home-hero-sec  min-h-full bg bg-home-hero  flex items-center justify-center">
    <div className="container lg:grid lg:grid-cols-12 lg:gap-10">
      <Box className="flex flex-col justify-center items-center lg:items-start text-center lg:text-left lg:col-span-7 ">
        <Typography
          className="text-2xl text-gray-500"
          variant="subtitle1"
          component="span"
        >
          Hello There,
        </Typography>
        <Typography variant="h6" gutterBottom component="h1">
          <span className=" block my-3 text-4xl uppercase font-normal tracking-wider">
            I'm Amr Saad Abdallah
          </span>
          <span className="text-primary-dark border border-dotted border-primary-dark rounded-md px-2 py-1 text-lg sm:text-2xl font-normal uppercase tracking-wider">
            Frontend Developer
          </span>
        </Typography>

        <Typography className="mt-2  italic hidden sm:block">
          I have a passion for programming and code, always looking for new
          tools and improve my skills through continuous self-learning and code
          a long, design responsive websites using HTML5, CSS3, Sass, Bootstrap,
          Tailwind CSS, JavaScript, ES6, and also JS frameworks like ReactJS.{' '}
          <Button component={Link} to="/about" variant="text" size="small">
            more details ...
          </Button>
        </Typography>

        <Box className="mt-4">
          <Button
            variant="outlined"
            size="medium"
            href="https://github.com/amrsaadabdallah/resume"
            target="_blank"
          >
            resume
          </Button>
          <Button
            component={Link}
            to="/portfolio"
            className="ml-4 sm:ml-6"
            variant="contained"
            size="medium"
          >
            portofolio
          </Button>
        </Box>
      </Box>

      <Box className="hidden lg:block lg:col-span-5 ">
        <img
          className="w-full"
          src={frontendAvatarUrl}
          alt="Frontend Developer Avatar"
        />
      </Box>
    </div>
  </section>
);

export default Hero;
